'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});


var Vue = require('vue');

exports.default = Vue.component('input-prompt', {
    props: ['label'],
    data: function data() {
        return {
            value: '',
            state: 'pre'
        };
    },
    methods: {
        prompt: function prompt() {
            var _this = this;

            this.state = 'prompt';
            this.$nextTick(function () {
                _this.$el.querySelector('input').focus();
            });
        },
        complete: function complete() {
            this.$emit('submit', this.value);
            this.state = 'pre';
        },
        cancel: function cancel() {
            this.$emit('cancel');
            this.state = 'pre';
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/customized-core/utils/InputPrompt.vue
// module id = lcxM
// module chunks = 1